export default __webpack_public_path__ + "static/continuous-compliance2-55e0702552bb67883da8b328d056f432.jpg";